import { useStore } from "@nanostores/preact";
import { factsLine, healthRows } from "../room/health";
import { $inspector, scrub, selectClip, setSpeed, SPEEDS, toggle, togglePlay, updateState } from "../room/inspectorState";
import { $panel } from "../state/stores";
import { Panel } from "./Panel";
import { $touchMode } from "../state/touch";

export function InspectorPanel() {
  const v = useStore($inspector);
  const touch = useStore($touchMode);
  if (!v) return null;
  const clip = v.clips[v.state.clip];
  const playable = !!clip && clip.duration > 0;
  return (
    <Panel title={v.name} side onClose={() => $panel.set(null)}>
      <p class="hint">{v.code}　{touch ? "拖曳旋轉、雙指縮放，點 ✕ 回到走路" : "拖曳旋轉、滾輪縮放，Esc 回到走路"}</p>
      {v.status === "loading" && <p class="hint">載入中…</p>}
      {v.status === "failed" && <p class="error">無法載入這個模型</p>}
      {v.status === "ready" && v.clips.length === 0 && <p class="hint">這個模型沒有動作</p>}
      {v.status === "ready" && v.clips.length > 0 && (
        <>
          <ul class="clip-list">
            {v.clips.map((c, i) => (
              <li key={i}>
                <button class={i === v.state.clip ? "" : "secondary"} onClick={() => updateState((s, cl) => selectClip(s, i, cl))}>
                  {c.name}（{c.duration.toFixed(2)} s）
                </button>
              </li>
            ))}
          </ul>
          <button disabled={!playable} onClick={() => updateState(togglePlay)}>{v.state.playing ? "暫停" : "播放"}</button>
          <input type="range" min={0} max={clip?.duration ?? 0} step={0.01} value={v.state.time} disabled={!playable}
            onInput={(e) => updateState((s, cl) => scrub(s, Number((e.target as HTMLInputElement).value), cl))} />
          <div class="clip-time">{v.state.time.toFixed(2)} / {(clip?.duration ?? 0).toFixed(2)} s</div>
          <div>
            {SPEEDS.map((sp) => (
              <button key={sp} class={sp === v.state.speed ? "" : "secondary"} onClick={() => updateState((s) => setSpeed(s, sp))}>{sp}×</button>
            ))}
          </div>
        </>
      )}
      <div class="inspector-toggles">
        <label><input type="checkbox" checked={v.state.skeleton} disabled={!v.hasSkeleton} onChange={() => updateState((s) => toggle(s, "skeleton"))} />骨架</label>
        <label><input type="checkbox" checked={v.state.grid} onChange={() => updateState((s) => toggle(s, "grid"))} />格線</label>
        <label><input type="checkbox" checked={v.state.ruler} onChange={() => updateState((s) => toggle(s, "ruler"))} />1.8 m 身高尺</label>
      </div>
      <h3>健檢</h3>
      {v.report ? (
        <>
          <table class="health">
            <tbody>
              {healthRows(v.report).map((r) => (
                <tr key={r.label} class={r.ok ? "" : "warn"}><td>{r.ok ? "✓" : "⚠"}</td><td>{r.label}</td><td>{r.text}</td></tr>
              ))}
            </tbody>
          </table>
          <p class="hint">{factsLine(v.report)}。⚠ 只是提醒，不影響使用。</p>
        </>
      ) : (
        <p class="hint">健檢資料尚未產生</p>
      )}
    </Panel>
  );
}
